import { render, staticRenderFns } from "./addServices.vue?vue&type=template&id=1ddc0938"
import script from "./addServices.vue?vue&type=script&lang=js"
export * from "./addServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports